import React, { useEffect, useState } from 'react';
import { get } from '@/features/shared/lib/api';
import ExtraLinks from '@/features/journal/components/ExtraLinks';
import { ChartSkeletonLoader } from '@/features/shared/ui/ChartSkeletonLoader';

export default function JournalRightBox({ record }) {
  const [indexDates, setIndexDates] = useState(null);
  const [indexDatesLoading, setIndexDatesLoading] = useState(false);

  // API에서 indexDates 데이터 가져오기
  useEffect(() => {
    let alive = true;
    (async () => {
      setIndexDatesLoading(true);
      try {
        const res = await get('/rm/v1/journal/indexing_update_dates');
        if (!alive) return;
        setIndexDates(res?.result || null);
      } catch (e) {
        console.error('[JournalRightBox] API error:', e);
      } finally {
        if (alive) setIndexDatesLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="right-box hidden mt-[105px] w-[310px] lg:block sticky top-[140px]">
      {/* Extra Links */}
      <ExtraLinks record={record} />

      <div className="w-full p-8 mt-8 bg-white rounded-xl">
        <h2 className="flex items-center gap-[6px] mb-5">
          <img src={`${rmVars.themeUrl}images/notice-ico.png`} className="w-[22px]" alt="link icon" />
          <span className="text-[18px] font-bold">Notice</span>
        </h2>
        <div className="relative min-h-[100px]">
          {indexDates && (
            <div dangerouslySetInnerHTML={{ __html: indexDates }} />
          )}
          {/* 로딩 상태 오버레이 */}
          <ChartSkeletonLoader show={indexDatesLoading} />
        </div>
      </div>
    </div>
  );
}
